<template>
  <div class="aboutShow">
    <div class="zxzx_div">
      <!-- <ul class="zxzx_ul">
        <li>关于展会</li>
        <li
          @click="liName('zhjs', 13)"
          :class="[tabName === 'zhjs' ? 'liActive' : '']"
        >
          展会介绍
        </li>
        <li
          @click="liName('bjzh', 14)"
          :class="[tabName === 'bjzh' ? 'liActive' : '']"
        >
          本届展会
        </li>
        <li
          @click="liName('lsyg', 15)"
          :class="[tabName === 'lsyg' ? 'liActive' : '']"
        >
          历史沿革
        </li>
      </ul> -->
      <el-menu
        :default-active="routePath"
        class="el-menu-vertical-demo zxzx_ul"
        active-text-color="#143372"
        :router="true"
      >
        <el-menu-item>
          <span slot="title">关于展会</span>
        </el-menu-item>
        <el-menu-item index="/aboutShow/exhibitorIntroduction">
          <span slot="title">展会介绍</span>
        </el-menu-item>
        <!-- <el-menu-item index="/aboutShow/thisExhibitor">
          <span slot="title">本届展会</span>
        </el-menu-item> -->
        <el-menu-item index="/aboutShow/historyEvolution">
          <span slot="title">历史沿革</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right_content">
      <!-- <about-exhibitor-intro
        v-if="tabName === 'zhjs'"
        :dataList="dataList"
      ></about-exhibitor-intro>
      <about-this-exhibitor
        v-if="tabName === 'bjzh'"
        :dataList="dataList"
      ></about-this-exhibitor>
      <about-history-evolution
        v-if="tabName === 'lsyg'"
        :dataList="dataList"
      ></about-history-evolution> -->
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import aboutExhibitorIntro from "./AboutExhibitorIntroduction";
import aboutThisExhibitor from "./AboutThisExhibitor";
import AboutHistoryEvolution from "./AboutHistoryEvolution";
export default {
  name: "aboutShow", // 关于展会
  components: {
    aboutExhibitorIntro,
    aboutThisExhibitor,
    AboutHistoryEvolution,
  },
  data() {
    return {
      tabName: "",
      dataList: [],
      routePath: ""
    };
  },
  computed: {
    getEventRouteLiName() {
      return this.$store.state.allRouteLiName;
    },
    getEventRouteLiNum() {
      return this.$store.state.num;
    },
  },
  watch: {
    getEventRouteLiName(val) {
      this.tabName = val;
    },
    getEventRouteLiNum(newVal) {
      this.liName(this.tabName, newVal);
    },
    $route(to) {
      this.routePath = to.path;
    }
  },
  activated() {
    let path = this.$route.path;
    this.routePath = path;
    // let sessionStore = JSON.parse(sessionStorage.getItem("mainStore"));
    // if (sessionStore && sessionStore.name) {
    //   switch (sessionStore.name) {
    //     case "zhjs":
    //       this.liName(sessionStore.name, sessionStore.num);
    //       break;
    //     case "bjzh":
    //       this.liName(sessionStore.name, sessionStore.num);
    //       break;
    //     case "lsyg":
    //       this.liName(sessionStore.name, sessionStore.num);
    //       break;
    //     default:
    //       this.liName("zhjs", 13);
    //   }
    // } else {
    //   this.liName("zhjs", 13);
    // }
  },
  mounted() {},
  methods: {
    liName(e, num) {
      sessionStorage.setItem(
        "mainStore",
        JSON.stringify({ name: e, num: num })
      );
      this.tabName = e;
      this.$http({
        url: "getInformationList",
        method: "post",
        params: {
          type: num,
        },
      })
        .then(({ data }) => {
          let { code, informationByTypeList } = data;
          if (code === 0) {
            this.dataList = [];
            this.dataList = informationByTypeList;
          }
        })
        .catch((err) => console.log(err));
    },
  },
  beforeRouteLeave(to, from, next) {
    // this.$store.commit("SET_ROUTE_LI_NUM", "");
    // this.$store.commit("SET_ROUTE_LI_NAME", "");
    next();
  },
};
</script>
<style lang="scss" scoped>
.aboutShow {
  min-height: 1177px;
  .zxzx_div {
    width: 238px;
    //height: 256px;
	 height: 191px;
    border-right: 1px solid #4bbc81;
    border-bottom: 1px solid #4bbc81;
    border-left: 1px solid #02b3ea;
    float: left;
    .zxzx_ul {
      font-weight: bold;
      li {
        width: 238px;
        height: 64px;
        line-height: 64px;
        padding-left: 0 !important;
        text-indent: 31px;
        font-size: 16px;
        color: #999999;
        cursor: pointer;
        &:hover {
          background-color: #ffffff;
        }
      }
      .is-active {
        background-color: #ffffff;
      }
      li:first-child {
        font-size: 24px;
        font-weight: normal;
        color: #fff;
        cursor: default;
        background-image: linear-gradient(to right, #02b3ea, #4bbc81);
      }
      li:nth-child(3) {
        height: 62px;
        border-top: 1px dashed #f2f2f2;
        border-bottom: 1px dashed #f2f2f2;
      }
    }
  }
  .right_content {
    width: 936px;
    float: right;
  }
  .liActive {
    color: #143372;
  }
}
</style>